<template>
    <MiscLink to="/" class="block" data-cy="logo">
        <span class="sr-only">{{ $t('layout.logo.link.title') }}</span>
        <MiscIcon name="logo-all4golf" :class="logoSizeClass" />
    </MiscLink>
</template>

<script setup lang="ts">
const props = withDefaults(defineProps<{
    size?: string;
}>(), {size: 'md'})

const logoSizeClass = reactive({
    'w-auto aspect-[143/48]': true,
    'h-10 lg:h-12': props.size === 'md',
    'h-10': props.size === 'sm',
    'h-6 lg:h-12': props.size === 'header',
})
</script>
